import { useAutosaveReport } from "hooks/useAutosaveReport";
import LoadingIndicator from "../LoadingIndicator";
import { AutosaveReportContext } from "Context/AutosaveReportContext";

const AutosaveReport = (props) => {
  const { showOverlay, triggerAutosave } = useAutosaveReport(props);

  return (
    <AutosaveReportContext.Provider value={{ triggerAutosave }}>
      {props.children}
      {showOverlay && (
        <div
          id="autosaveOverlay"
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.25)",
            backdropFilter: "blur(2px)",
            zIndex: 9999999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "auto",
            cursor: "wait",
            transition: "opacity 0.3s ease",
          }}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.preventDefault()}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "1.5rem 2rem",
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "0.75rem",
              minWidth: "220px",
            }}
          >
            <LoadingIndicator />
            <p style={{ fontSize: "1rem", fontWeight: 500, color: "#333", textAlign: "center", margin: 0 }}>
              Please wait...
              <span style={{ fontSize: "0.9rem", color: "#777", display: "block" }}>
                Your inputs are being saved. <br />
                Any edits made during the auto-save process may not be recorded.
              </span>
            </p>
          </div>
        </div>
      )}
    </AutosaveReportContext.Provider>
  );
};

export default AutosaveReport;
